import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  CollapsibleStyled,
  OuterContainer,
  InnerContainer,
  TriggerButton,
  TriggerButtonWrap,
  StyledText,
  StyledIcon,
} from './styles/CollapsibleStyled';

const OPEN_STATE = {
  OPEN: 'open',
  CLOSE: 'close',
};

class Collapsible extends PureComponent {
  constructor(props) {
    super(props);
    const { defaultOpen } = this.props;
    let state;
    if (defaultOpen) {
      state = {
        openState: OPEN_STATE.OPEN,
        height: 'auto',
      };
    } else {
      state = {
        openState: OPEN_STATE.CLOSE,
        height: 0,
      };
    }
    this.state = state;
  }

  UNSAFE_componentWillReceiveProps({ defaultOpen }) {
    const { defaultOpen: prevDefaultOpen } = this.props;
    if (defaultOpen !== undefined && prevDefaultOpen !== defaultOpen) {
      this.setState({
        openState: defaultOpen ? OPEN_STATE.OPEN : OPEN_STATE.CLOSE,
        height: defaultOpen ? 'auto' : 0,
      });
    }
  }

  onInnerRef = (ref) => {
    this.inner = ref;
  };

  onOuterRef = (ref) => {
    this.outer = ref;
  };

  handleTriggerClick = (e) => {
    e.preventDefault();
    const { handleTriggerClick, accordionPosition, triggerDisabled } = this.props;
    const { openState } = this.state;

    if (triggerDisabled === true) {
      return;
    }

    if (handleTriggerClick === true) {
      handleTriggerClick(accordionPosition);
    } else if (openState === OPEN_STATE.CLOSE) {
      this.openCollapsible();
    } else if (openState === OPEN_STATE.OPEN) {
      this.closeCollapsible();
    }
  };

  closeCollapsible = () => {
    const { genreId, onToggle } = this.props;
    this.setState({
      height: 0,
      openState: OPEN_STATE.CLOSE,
    });
    onToggle(false, genreId); // activate scrollbar forceUpdate, set category open/close state in localStorage
  };

  openCollapsible = () => {
    const { genreId, onToggle } = this.props;
    this.setState({
      height: this.inner.offsetHeight,
      openState: OPEN_STATE.OPEN,
    });
    onToggle(true, genreId); // activate scrollbar forceUpdate, set category open/close state in localStorage
  };

  render() {
    const { triggerText, triggerIcon, children } = this.props;

    const { height, openState } = this.state;

    const dropDownStyle = {
      height,
    };

    return (
      <CollapsibleStyled>
        <TriggerButton onClick={this.handleTriggerClick}>
          <TriggerButtonWrap>
            <StyledIcon
              active={openState === OPEN_STATE.OPEN}
              name={triggerIcon}
              color="gray_lightsmoke"
              size={12}
            />
            <StyledText color="gray_lightsmoke" font="din_bold" type="uppercase" spacing={1}>
              {triggerText}
            </StyledText>
          </TriggerButtonWrap>
        </TriggerButton>
        <OuterContainer ref={this.onOuterRef} style={dropDownStyle} data-role="collapsibleContent">
          <InnerContainer ref={this.onInnerRef}>{children}</InnerContainer>
        </OuterContainer>
      </CollapsibleStyled>
    );
  }
}

Collapsible.propTypes = {
  defaultOpen: PropTypes.bool,
  accordionPosition: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleTriggerClick: PropTypes.func,
  onToggle: PropTypes.func,
  triggerText: PropTypes.string,
  triggerIcon: PropTypes.string,
  triggerDisabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  genreId: PropTypes.number,
};

Collapsible.defaultProps = {
  defaultOpen: false, // Set to true if you want the Collapsible to begin in the open state. You can also use this prop to manage the state from a parent component.
  triggerDisabled: false, // Disables the trigger handler if true. Note: this has no effect other than applying the _state_disabled CSS class if you've provided a handleTriggerClick prop.
  onToggle: Function.prototype, // Is called when the Collapsible toggle.
  handleTriggerClick: Function.prototype, // Define this to override the click handler for the trigger link. Takes one parameter, which is props.accordionPosition
  accordionPosition: '', // Unique key used to identify the Collapse instance when used in an accordion.
  triggerText: '', // Set Trigger text
  children: '',
  triggerIcon: 'arrow_left',
  genreId: 0,
};

export default Collapsible;
